<template>
  <div class="slack text-center">
    <br />
    <h4>
      O Slack é a ferramenta de comunicação utilizada pela NetSupport. Uma das
      pendências que todo supporter deve
      <b>pagar</b> é criar um usuário no Slack.
    </h4>

    <div class="text-center box">
      <br />
      - <b>ATENÇÃO!!!</b> O e-mail utilizado para criar a conta no Slack deve
      ser o mesmo utilizado para se cadastrar no portal! <br /><br />
    </div>

    <h5>
      <br />- Se você já criou sua conta, basta clicar no botão abaixo para
      sincronizar seu usuário com Slack.<br />Se estiver tudo certo sua
      pendência será paga no processo.
    </h5>
    <div class="text-center">
      <Button layout="white-m" @click="accept_slack">
        <img
          width="25"
          src="../../assets/img/logo_slack.svg"
          alt="Sincroniza Slack"
        />
        Sincronizar com Slack
      </Button>
    </div>
    <br />
    <h5>
      <br /><br />
      Se você ainda não criou sua conta no slack,
      <a id="btn-cria-conta" target="_blank" :href="api.supporter.slack.invite"
        >crie sua conta agora clicando aqui</a
      >.<br />
      Depois de criada a conta, retorne a esta página para fazer a sincronização
      e pagar a pendência.
    </h5>
    <br />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Api from "@/conf/Api";
import Button from "@/components/Button.vue";
export default {
  name: "Slack",
  props: { pendency: Object },
  components: {
    Button,
  },
  data() {
    return {
      api: Api,
    };
  },
  methods: {
    ...mapActions("user", ["ACCEPT_SLACK"]),
    accept_slack() {
      this.ACCEPT_SLACK().then((r) => {
        if (r.status === 200 || r.status === 201) {
          if (this.modal.callback) this.modal.callback();
          this.modal.show = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.slack {
  padding: 45px 35px;
  font-size: 18px;
  max-width: 700px;

  .box {
    background: $white-2;
    border-radius: 9px;
    padding: 12px;
  }
  .title {
    font-size: 22px;
    font-weight: 600;
  }
  .content {
    color: $gray-1;
    text-align: justify;
    font-size: 12px;
    margin-top: 35px;
    line-height: 27px;
    height: 100vh;
    overflow: auto;
  }
  a {
    color: $green-2;
    font-size: 16px;
  }
}
</style>